import { Component, OnInit, OnDestroy, Output, ViewChild, ViewContainerRef } from '@angular/core';
import {CellClickedEvent, GridOptions} from 'ag-grid';
import { EventEmitter } from '@angular/common/src/facade/async';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { ReservationService } from '../../../trip-reservations/reservations.service';
import { UsersService } from '../../../users/users.service';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import {EscalationService} from '../../../../services/escalation.service';
import {assignNewObjet, generateAlertColumn, iconAlert, viewMessageAlertRider} from '../../../A2-utils/export-functions/functions-services';
import {ITripDetail} from '../../../../core/interfaces/trip-detail.interface';
import {EnumTypeAlertRider, RiderAlertService} from '../../../rider/services/rider-alert.service';
import {Subscription} from 'rxjs/Subscription';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { GridLayoutStore } from 'app/utils/grid-layout-menu/grid-layout-store';

const ESCALATIONS_ACTION_ID = 120;

@Component({
  selector: 'app-trips-escalations',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.scss'],
  providers: [GridLayoutStore]
})
export class TripsComponent implements OnInit, OnDestroy  {

  public modalStatusVisible = false;
  public modalReservationVisible = false;
  protected isOpenAppRidersCreate: boolean;

  protected date: any;
  protected gridTrips: GridOptions;
  protected currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  protected timer: any;
  protected selectedVehicle: any;
  protected selectedStatus: any = 'All';
  protected selectedTrip: any = null;
  protected selectedProvider: any;
  protected filterStatus = [
    'Open',
    'Hold',
    'Active',
    'Arrived',
    'Accepted',
    'Rejected',
    'Pickup',
    'NoShow',
    'Completed',
    'Cancelled',
    'Closed'
  ];
  protected countGridTrips = 0;
  protected isLoading = false;
  protected isProvider = JSON.parse(localStorage.getItem('currentUser')).usertypeid === 2;

  providerid;

  @ViewChild('modalStatus') private modalStatus: T2CardComponent;
  @ViewChild('modalReservation') private modalReservation: T2CardComponent;

  @Output() loadingMask: EventEmitter < any > = new EventEmitter < any > ();
  private observables: Subscription[] = [];
  constructor(
    private toastrAlertHelper: ToastrAlertHelper,
    protected service: ReservationService,
    protected _serviceUser: UsersService,
    protected _loading: T2LoadingService,
    private _serviceEscalationService: EscalationService,
    private _riderAlertService: RiderAlertService,
    private layoutStore: GridLayoutStore,
  ) {
    this.gridTrips = < GridOptions > {
      enableSorting: true,
      sortingOrder: ['desc', 'asc', null],
      onFilterModified: () => {
        this.countGridTrips = this.gridTrips.api.getDisplayedRowCount();
      }
    };
    this.gridTrips.columnDefs = this.createColums();

    this.gridTrips.getRowClass = (params) => {
      return this.validateStatusColor(params);
    };

    this.getLayout();
  }

  ngOnInit() {
    this.publishLayout();
    this.getTrips();
    this.timer = setInterval(() => {
      this.getTrips();
      }, (20 * 1000) );
  }

  private publishLayout() {
    this.layoutStore.set({
      grid: this.gridTrips,
      moduleActionId: ESCALATIONS_ACTION_ID,
      title: 'Escalations',
      buttonClass: 'm-btn m-btn-primary margin margin-r-5'
    });
  }

  ngOnDestroy() {
    clearInterval(this.timer);
    this.observables.forEach(sub => sub.unsubscribe());
  }

  /**
   * get trips data by date and provider
   * @param selectedTrips
   * @param {boolean} noShowLoading
   */
  getTrips() {
    this.observables.push(this._serviceEscalationService.getTripsEscalations().subscribe(
      data => {
        let model;
        if ( this.gridTrips.api) {
          model = this.gridTrips.api.getFilterModel();
        } else {
          model = {};
        }
        if (this.gridTrips) {
          if (this.gridTrips.api) {
            this.gridTrips.api.setRowData(data);
          }
        }

        this.setFilterModelToGrid(model);
        this.loadingMask.emit(false);
        this.countGridTrips = this.gridTrips.api.getDisplayedRowCount();
      }
    ));
  }

  /**
   * this set filter model to grid
   * @param model
   */
  private setFilterModelToGrid(model) {
    this.gridTrips.api.setFilterModel(model);
    this.gridTrips.onFilterChanged = function () {};
    this.gridTrips.api.refreshView();
  }

  /**
   * this reselect selected trips after reload
   * @param selectedTrips
   */
  private reselectItems(selectedTrips ? ) {
    if (selectedTrips) {
      this.gridTrips.api.forEachNodeAfterFilter((node) => {
        selectedTrips.forEach((tripid) => {
          if (tripid === node.data.tripid) {
            node.setSelected(true);
          }
        });
      });
    }
  }

  /**
   * this export grid data to excel file
   */
  exportToExcel() {
    const selectedNodes = this.gridTrips.api.getSelectedNodes();
    if (selectedNodes.length !== 0) {
      this.gridTrips.api.exportDataAsExcel(this.paramsToExport_PR());
    } else {
      this.toastrAlertHelper.info('Please select at least one record');
    }
  }

  /**
   * this save user layout
   */
  public saveLayout() {
    const stringLayout = JSON.stringify(this.gridTrips.columnApi.getColumnState());
    const data = {
      moduleActionId: ESCALATIONS_ACTION_ID,
      config: stringLayout
    };

    this.service
      .postSaveLayout(data)
      .subscribe(
        success => {
          this.toastrAlertHelper.success('Update your preferences to this grid', 'Success');
        }
      );
  }

  /**
   * this method is implement from older code
   * @returns {{skipHeader: boolean; columnGroups: boolean; skipFooters: boolean;
   * skipGroups: boolean; allColumns: boolean; onlySelected: boolean; fileName: string}}
   */
  public paramsToExport_PR() {
    const params = {
      skipHeader: false,
      columnGroups: true,
      skipFooters: true,
      skipGroups: false,
      allColumns: true,
      onlySelected: true,
      fileName: 'Trips'
    };
    return params;
  }

  /**
   * this export grid data to csv file
   */
  public exportToCsv() {
    this.gridTrips.api.exportDataAsCsv(this.paramsToExport_PR());
  }

  /**
   * return the selected trips
   * @returns {any[]}
   */
  private getSelectedTripsId() {
    const tripsid = [];
    if (this.gridTrips.api !== null) {
      this.gridTrips.api.forEachNodeAfterFilter((node) => {
        if (node.isSelected()) {
          tripsid.push(node.data.tripid);
        }
      });
    }
    return tripsid;
  }

  /**
   * this get layout data from server
   */
  private getLayout() {
    this.service.getRoleActionByModule(44).subscribe(
      data => {
        data.forEach((val) => {
          if (val.action.description === 'Read' && val.layout && this.gridTrips && this.gridTrips.columnApi) {
            this.gridTrips.columnApi.setColumnState(JSON.parse(val.layout.config));
          }
        });
      }
    );
  }

  /**
   * open modal with change massive status
   */
  public openChangeStatus() {
    if (this.getSelectedTripsId().length !== 0) {
      this.openModalStatus();
    } else {
      this.toastrAlertHelper.error('Please select a trip');
    }
  }

  openModalStatus() {
    this.modalStatus.open();
    this.modalStatusVisible = true;
  }

  closeModalStatus() {
    this.modalStatus.close();
    this.modalStatusVisible = false;
  }

  openModalReservation() {
    this.modalReservation.open();
    setTimeout(() => {
      this.modalReservationVisible = true;

    }, 2000);
  }

  /**
   * Cell Color Validate
   * @param params
   * @returns {any}
   */
  private validateStatusColor(params) {
    if (params.data.tripstatus === 'Closed') {
      return 'trip_closed';
    }

    if (params.data.tripstatus === 'Cancelled') {
      return 'trip_cancelled';
    }

    if (params.data.tripstatus === 'Assigned') {
      return 'trip_assigned';
    }

    if (params.data.tripstatus === 'Pickup') {
      return 'trip_pickup';
    }

    if (params.data.tripstatus === 'Completed') {
      return 'trip_complete';
    }

    if (params.data.tripstatus === 'NoShow') {
      return 'trip_noShow';
    }
  }

  /**
   * this execute when status is changed
   */
  public changeTripsStatus() {
    this.getTrips();
    this.selectAllRows(false);
  }

  /**
   * this select all rows
   * @param selected
   */
  private selectAllRows(selected) {
    if (this.gridTrips.api !== undefined) {
      this.gridTrips.api.forEachNode((node) => {
        node.setSelected(selected);
      });
    }
  }

  /**
   * this clear all grid filter
   */
  private clearFilter() {
    this.selectedStatus = 'All';
    this.gridTrips.api.setFilterModel(null);
    this.countGridTrips = this.gridTrips.api.getDisplayedRowCount();
  }

  /**
   * this clear all sort on the grid
   */
  private clearSort() {
    this.gridTrips.api.setSortModel(null);
  }

  /**
   * Columns
   */
  createColums() {
    const columns = [{
      colId: 'check',
      width: 30,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
      generateAlertColumn(),
      {
        headerName: 'Provider',
        field: 'company',
        colId: 'company',
        width: 80,
        hide: this.isProvider,
        suppressFilter: this.isProvider,
        suppressToolPanel: this.isProvider
      },
      {
        headerName: 'Prov. Status',
        field: 'providerstatus',
        colId: 'providerstatus',
        width: 80,
        suppressFilter: true,
        hide: true,
        suppressToolPanel: true
      },
      {
        headerName: 'Reservation',
        field: 'consecutive',
        colId: 'consecutive',
        width: 80
      },
      {
        headerName: 'Company',
        field: 'broker',
        colId: 'broker',
        width: 80,
        hide: this.isProvider,
        suppressFilter: this.isProvider,
        suppressToolPanel: this.isProvider
      },
      // {
      //   headerName: 'Trip´ID',
      //   field: 'tripid',
      //   colId: 'tripid',
      //   width: 70
      // },
      {
        headerName: 'vehiclecode',
        field: 'vehiclecode',
        colId: 'vehiclecode',
        width: 120,

      },
      {
        headerName: 'Status',
        field: 'tripstatus',
        colId: 'status',
        width: 60
      },
      {
        headerName: 'Driver',
        field: 'drivername',
        colId: 'Driver',
        width: 150,
      },
      {
        headerName: 'Driver Phone',
        field: 'driverphone',
        colId: 'driverphone',
        width: 100,
      },
      {
        headerName: 'Rider Information',
        children: [{
          headerName: 'Rider',
          field: 'ridername',
          colId: 'ridername',
          width: 150
        },
          {
            headerName: 'Phone',
            field: 'riderphonenumber',
            colId: 'ridername',
            width: 150
          },
          {
            headerName: 'Age',
            field: 'riderage',
            colId: 'ridername',
            width: 55
          },
          {
            headerName: 'Payor',
            field: 'payor',
            colId: 'payor',
            width: 80,
            hide: this.isProvider,
            suppressFilter: this.isProvider,
            suppressToolPanel: this.isProvider
          }
        ]
      },
      {
        headerName: 'Service',
        field: 'servicetype',
        colId: 'service',
        width: 80
      },

      {
        headerName: 'Date',
        field: 'dateofservice',
        colId: 'date',
        width: 75,

      },
      {
        headerName: 'Leg',
        field: 'leg',
        colId: 'leg',
        width: 35
      },
      {
        headerName: 'Appointment',
        field: 'appointmenttime',
        colId: 'appointmenttime',
        width: 80
      },
      {
        headerName: 'Pick-Up',
        children: [{
          headerName: 'PU Time',
          field: 'pickup',
          colId: 'puTime',
          width: 120
        },
          {
            headerName: 'ActualPU',
            field: 'actualpickup',
            colId: 'puTime',
            width: 120
          },

          {
            headerName: 'Address',
            field: 'triplocationpickup.streetaddress',
            colId: 'puaddresss',
            width: 120
          },

          {
            headerName: 'City',
            field: 'triplocationpickup.city',
            colId: 'puCity',
            width: 120
          },
          {
            headerName: 'ZipCode',
            field: 'triplocationpickup.zip',
            colId: 'zipP',
            width: 120
          },
          {
            headerName: 'Geo',
            field: 'iscoordpickupvalid',
            cellRendererFramework: BooleanCheckComponent,
            colId: 'iscoordpickupvalid',
            width: 120,

          },
          {
            headerName: 'County',
            field: 'triplocationpickup.county',
            colId: 'county',
            width: 120,
          }

        ]
      },
      {
        headerName: 'Drop-Off',
        children: [{
          headerName: 'Actual Drop',
          field: 'actualdropoff',
          colId: 'doaddresss',
          width: 120
        },
          {
            headerName: 'Address',
            field: 'triplocationdropoff.streetaddress',
            colId: 'doaddresss',
            width: 120
          },
          {
            headerName: 'Actual Drop',
            field: 'actualdropoff',
            colId: 'doaddresss',
            width: 120
          },
          {
            headerName: 'City',
            field: 'triplocationdropoff.city',
            colId: 'doCity',
            width: 120
          },
          {
            headerName: 'ZipCode',
            field: 'triplocationdropoff.zip',
            colId: 'zipD',
            width: 120
          },
          {
            headerName: 'Geo',
            field: 'iscoorddropoffvalid',
            cellRendererFramework: BooleanCheckComponent,
            colId: 'iscoorddropoffvalid',
            width: 120,

          },
          {
            headerName: 'County',
            field: 'triplocationdropoff.county',
            colId: 'county',
            width: 120,
          }
        ]
      },
      {
        headerName: 'Loaded Miles',
        field: 'loadedmiles',
        colId: 'loadedmiles',
        width: 120,

      },
      {
        headerName: 'Authorization',
        field: 'payorauthorization',
        colId: 'payorauthorization',
        width: 120,
        hide: this.isProvider,
        suppressFilter: this.isProvider,
        suppressToolPanel: this.isProvider
      },
      {
        headerName: 'VIP',
        field: 'isridervip',
        cellRendererFramework: BooleanCheckComponent,
        colId: 'vip',
        width: 70,

      },
      {
        headerName: 'Confirmed',
        field: 'tripconfirmed',
        cellRendererFramework: BooleanCheckComponent,
        colId: 'tripconfirmed',
        width: 70,
      },
      {
        headerName: 'Pymt Status',
        field: 'paymentstatus',
        colId: 'paymentstatus',
        width: 70
      },
      {
        headerName: 'Prov Pay',
        field: 'provideramount',
        colId: 'provideramount',
        width: 70
      }
    ];
    return columns;
  }

  /**
   * @description verifica si tiene alert y llama al servicio
   */
  private showAlert(event: CellClickedEvent): void {
    if (event.colDef.field === 'hasrideralert' && event.value) {
      const data: ITripDetail = assignNewObjet(event.data);
      this.getRiderAlerts(data.riderid, data.ridername);
    }
  }
  /**
   * @description trae alert y las muestra
   */
  private getRiderAlerts(riderId: number, name: string): void {
    this._loading.show();
    this.observables.push(this._riderAlertService.getAlertRiderByTypes(riderId, EnumTypeAlertRider.Dispatch).subscribe(
      (success: string[]) => {
        this._loading.hiden();
        viewMessageAlertRider(success, name);
      },
      error => {
        this._loading.hiden();
      }
    ));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/escalations/components/trips/trips.component.ts